import { render, staticRenderFns } from "./dashboardAreaChart.vue?vue&type=template&id=4af3e47d&"
import script from "./dashboardAreaChart.vue?vue&type=script&lang=js&"
export * from "./dashboardAreaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports